<template>
  <div class="wrap">
    <div class="spec card">
      <ProductGoodsSpecs
        v-if="info.id"
        :info="info"
        :goods_spec="goods_spec"
        @handleBuy="handleBuy"
        @handleCollect="handleCollect"
        @handleAddShoppingCart="handleAddShoppingCart"
      />
    </div>
    <div class="detail card">
      <div class="title">
        商品详情
        <div class="line"></div>
      </div>
      <div class="content">
        <img
          class="content-item"
          v-for="img_item in info.content_arr"
          :src="img_item"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { MallService, TrolleyService } from "@/common/service";
import ProductGoodsSpecs from "@/components/product/product-goods-specs";
export default {
  components: { ProductGoodsSpecs },
  data() {
    return {
      info: {}, // 数据
      goods_spec: {
        current: "",
        current_list: [],
        num: 1,
        spec_id: 0,
      },
    };
  },
  created() {
    const option = this.$route.query;
    if (option.id) this.getDetail(option.id);
    if (localStorage.getItem("user_info"))
      this.$store.dispatch("getMarkNum", "product");
  },
  activated() {
    const option = this.$route.query;
    if (option.id) this.getDetail(option.id);
    window.scrollTo(0, 0);
  },
  methods: {
    // 获取需求详情
    getDetail(goods_id) {
      MallService.getGoodsDetail({ goods_id }).then(({ data }) => {
        this.info = data.goods_info;
      });
    },
    // 加入购物车
    handleAddShoppingCart() {
      let not_select = this.goods_spec.current_list.find((i) => !i[1]);
      if (not_select) return this.$message.error("请选择" + not_select[0]);
      TrolleyService.addTrolley({
        goods_id: this.info.id,
        spec_id: this.goods_spec.spec_id,
        num: this.goods_spec.num,
      }).then(({ msg }) => {
        this.$store.dispatch("getMarkNum", "product");
        this.$message.success(msg);
      });
    },
    // 立即购买
    handleBuy() {
      let not_select = this.goods_spec.current_list.find((i) => !i[1]);
      let current_spec = this.info.item_list.find(
        (i) => i.id == this.goods_spec.spec_id
      );
      if (not_select) return this.$message.error("请选择" + not_select[0]);
      if (this.goods_spec.num > current_spec.stock)
        return this.$message.error("库存不足");
      this.$router.push({
        name: "product-confirm-order",
        params: {
          goods_id: this.info.id,
          spec_id: this.goods_spec.spec_id,
          num: this.goods_spec.num,
          type: "buy",
        },
      });
    },
    // 收藏
    handleCollect() {
      MallService.goodsCollect({
        id: this.info.id,
        status: 1 - this.info.is_collect,
      }).then(({ data, msg }) => {
        this.info.is_collect = data.status;
        this.$message.success(msg);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  margin: 0 auto;
  width: 1310px;
  padding-top: 20px;
  user-select: none;
  position: relative;
  .card {
    background-color: white;
    padding: 20px 30px;
    box-sizing: border-box;
  }
  .detail {
    margin-top: 20px;
    .title {
      width: 80px;
      font-size: 20px;
      font-weight: 500;
      color: #212121;
      position: relative;
      .line {
        position: relative;
        bottom: -10px;
        left: 26px;
        width: 32px;
        height: 4px;
        background: #0054f7;
      }
    }
    .content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 30px;
      font-size: 16px;
      .content-item {
        width: 790px;
      }
    }
  }
}
</style>
